/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { ExportState } from "./enums/export.state";
import { Template } from "./template";
import { User } from "./user";

export class ExportHistory {
  ID: string;
  EXPORT_DATE: Date;
  FILE_NAME: string;
  TEMPLATE: Template;
  STATE_SERVER: ExportState;
  STATE_CLIENT: ExportState;
  USER: User;

  constructor(value: any = {}) {
    Object.assign(this, value);

    if(value.USER)
      this.USER = User.parse(value.USER);

    if(value.TEMPLATE)
      this.TEMPLATE = Template.parse(value.TEMPLATE);
  }

  static parseArray(json: any[]): ExportHistory[] {
    const arr = [];
    if (json) {
      for (const j of json) {
        if (j) {
          arr.push(new ExportHistory(j));
        }
      }
    }

    return arr;
  }
}
